import { render, staticRenderFns } from "./LifetimePlans.vue?vue&type=template&id=fa4a99ba"
import script from "./LifetimePlans.vue?vue&type=script&lang=js"
export * from "./LifetimePlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports